import Vue from 'vue'
import FeatherIcon from '@/components/FeatherIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
